import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { fetchVMsListStart, fetchTaskStatusListStart } from "store/actions";
import { NOTIFICATIONS } from "consts";
import { openWithPost } from "utils";

function VMConsole(props) {
  const dotsRef = React.useRef(null);
  const [failedToBuildVM, setFailedToBuildVM] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const [checkingEmptyTasksAgainAfter10seconds, setRecheck] = useState(false);
  const [connectingToVI, setConnectingToVI] = useState(false);
  const [requestedForVMList, setRequestedForVMLisT] = useState(false);
  // console.log(urlParams.get('taskId'))
  // console.log(urlParams.get('clientUUID'))

  React.useEffect(() => {
    if (!failedToBuildVM) {
      let dotsArray = ["", ".", "..", "..."];
      let index = 0;
      const interval = setInterval(() => {
        if (!failedToBuildVM && dotsRef.current) {
          document.getElementById("dots").textContent = dotsArray[index];
          index = (index + 1) % dotsArray.length;
        }
      }, 500);
      return () => clearInterval(interval); // Cleanup on unmount
    }
  }, [failedToBuildVM]);

  React.useEffect(() => {
    props.fetchTaskStatusListStart();
    if (!urlParams.get("taskId") || !urlParams.get("clientUUID")) {
      setFailedToBuildVM(true);
    }
  }, []);

  React.useEffect(() => {
    if (props.taskIdList.length > 0) {
      setRecheck(false);
      const task = props.taskIdList.find(
        val => val.task_id === urlParams.get("taskId")
      );
      if (task) {
        if (task.status === "SUCCESS" && !connectingToVI) {
          // setRequestedForVMLisT(true);
          props.fetchVMsListStart(false);
        } else if (task.status === "FAILURE") {
          setFailedToBuildVM(true);
        }
      }
    } else if (props.taskIdList.length === 0) {
      if (!checkingEmptyTasksAgainAfter10seconds) {
        setRecheck(true);
        setTimeout(() => {
          setRequestedForVMLisT(true);
          props.fetchVMsListStart(false);
        }, 15000);
      }
    }
  }, [props.taskIdList]);

  React.useEffect(() => {
    if (!connectingToVI && props.vmsList.length > 0) {
      const vm = props.vmsList.find(
        val => val.client_uuid === urlParams.get("clientUUID")
      );

      if (checkingEmptyTasksAgainAfter10seconds && requestedForVMList) {
        // Process only if this is the delayed re-fetch
        if (vm) {
          setConnectingToVI(true);
          setFailedToBuildVM(false);
          const [url, token] = vm.connection_url.split("?token=");
          openWithPost(
            url,
            { token, source: process.env.REACT_APP_NAME },
            false
          );
        } else {
          setFailedToBuildVM(true);
        }
      } else if (!checkingEmptyTasksAgainAfter10seconds) {
        // Normal flow after task is SUCCESS
        if (vm) {
          setConnectingToVI(true);
          setFailedToBuildVM(false);
          const [url, token] = vm.connection_url.split("?token=");
          openWithPost(
            url,
            { token, source: process.env.REACT_APP_NAME },
            false
          );
        }
      }
    }
  }, [
    props.vmsList,
    checkingEmptyTasksAgainAfter10seconds,
    requestedForVMList
  ]);

  return (
    <div className="link-expire-page virtual-loading" cz-shortcut-listen="true">
      <div className="main_wrapper">
        <div className="sul_wrap">
          <div className="sul_inner">
            <div className="spw_header d_flex">
              {" "}
              <a href="" className="share_logo">
                {" "}
                <span className="logo_icon">Mirror</span>{" "}
              </a>{" "}
            </div>
            <div className="spw_body">
              {failedToBuildVM ? (
                <div className="spw_error"></div>
              ) : (
                <div className="spw_loader"></div>
              )}
              <div className="spw_expired_description">
                {failedToBuildVM ? (
                  <div className="loading">
                    <p className="spw_error_p">
                      Failed to create the virtual instance.
                    </p>
                    <p className="spw_error_p">
                      Go to the{" "}
                      <a href="/mirror/virtualization" className="link">
                        Virtualization
                      </a>{" "}
                      tab and try again.
                    </p>
                  </div>
                ) : (
                  <React.Fragment>
                    <div className="loading doublecontent">
                      <p className="spw_error_p">
                        Building virtual instance.
                        <span id="dots" ref={dotsRef}>
                          ..
                        </span>
                      </p>
                      <p className="spw_error_p">
                        Do not refresh or close this window
                      </p>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
        <p className="footer_signature">© IDrive Inc.</p>
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchVMsListStart,
      fetchTaskStatusListStart
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    vmsList: state.virtualization.vmsList,
    taskIdList: state.virtualization.taskIdList,
    randomDelay: state.virtualization.randomDelay
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VMConsole);
